const VERIFICATION_STATUS_VALIDATED = "validated";
export const getIsStatusValidated = (status) => status === VERIFICATION_STATUS_VALIDATED;
//# sourceMappingURL=getIsStatusValidated.js.map